import { Reducer } from 'redux';
import { PrescriptionActionTypes, PrescriptionState } from './type';

const initialState: PrescriptionState = {
  detail: {},
  list: {
    currentPage: 0,
    totalPage: 0,
    data: []
  },
  shoppingCart: {},
  coupon: [],   //购药时的优惠券
  servpack: [],  //购药时的服务包
}

const reducer: Reducer<PrescriptionState> = (state = initialState, action) => {
  switch (action.type) {
    case PrescriptionActionTypes.FETCH_PRESCRIPTION_DETAIL_SUCCESS: {
      const { data } = action;
      return {
        ...state,
        detail: data
      }
    }
    case PrescriptionActionTypes.FETCH_PRESCRIPTION_DETAIL_SUCCESS_BYINQUIRYID: {
      const { data } = action;
      return {
        ...state,
        detail: data
      }
    }
    case PrescriptionActionTypes.SET_PRESCRIPTION_DETAIL: {
      const { data } = action;
      return {
        ...state,
        detail: data
      }
    }
    case PrescriptionActionTypes.FETCH_PRESCRIPTION_LIST_SUCCESS: {
      const { data, totalPage, currentPage } = action;
      if (currentPage === 1) {
        return {
          ...state,
          list: {
            data,
            totalPage,
            currentPage
          }
        }
      }
      return {
        ...state,
        list: {
          data: [...state.list.data, ...data],
          totalPage,
          currentPage
        }
      }
    }
    case PrescriptionActionTypes.INIT_SHOPPINGCART: {
      const { data } = action;
      return {
        ...state,
        shoppingCart: data
      }
    }
    case PrescriptionActionTypes.EDIT_SHOPPINGCART: {
      const { key, value } = action;
      return {
        ...state,
        shoppingCart: {
          ...state.shoppingCart,
          [key]: value
        }
      }
    }
    case PrescriptionActionTypes.MODIFY_SHOPPINGCART: {
      const { key, value } = action;
      let orderGoods = state.shoppingCart.orderGoods.concat([]);
      orderGoods.forEach(element => {
        if (element.goodsId === key) { element.goodsNum = value; }
      });
      return {
        ...state,
        shoppingCart: {
          ...state.shoppingCart,
          orderGoods: orderGoods
        }
      }
    }

    case PrescriptionActionTypes.FETCH_ORDER_PRICE_SUCCESS: {
      const { data: { couponList = [], servpackList = [] } = {} } = action;
      //购药用的优惠券
      const coupon: any[] = [];

      couponList.length && couponList.forEach(element => {
        const item = {
          ...element.coupon,
          couponEffectiveTime: (element.couponEffectiveTime || '').replace(/-/g, "/"),
          couponExpiryTime: (element.couponExpiryTime || '').replace(/-/g, "/"),
          id: element.id,
          couponStatus: element.userCouponStatus
        };
        coupon.push(item);
      });
      return {
        ...state,
        coupon: coupon,
        servpack: servpackList,
      }
    }

    case PrescriptionActionTypes.DELETE_SHOPPINGCART: {
      return {
        ...state,
        shoppingCart: {}
      }
    }
    case PrescriptionActionTypes.ClEAN_PRESCRIPTION_DETAIL: {
      return {
        ...state,
        detail: {}
      }
    }
    default: {
      return state
    }
  }
}

export { reducer as PrescriptionReducer };